import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {UserRating} from '../types';
import {v8nSchemaOfGetRatingsResponse} from './backendSchemas';
import {GetRatingsResponse} from './backendTypes';
import {mapUserRatingFromBackend} from './dataMappers';

export const getRatings = async ({page, pageSize}: GetListParams = {}): Promise<
  GetListOutput<UserRating>
> => {
  const response = await axi.get<GetRatingsResponse>('/admin/ratings', {
    params: {
      page,
      per_page: pageSize,
    },
  });

  validateData(response.data, v8nSchemaOfGetRatingsResponse, 'getRatings');

  const {
    array,
    total,
    total_pages,
    page: pageFromBackend,
    per_page,
  } = response.data;
  const items = array?.map(item => mapUserRatingFromBackend(item)) ?? [];

  return {
    items,
    page: pageFromBackend,
    pageSize: per_page,
    total,
    totalPages: total_pages,
  };
};
